var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.599 0.400002H2.39902C1.07902 0.400002 0.0110234 1.48 0.0110234 2.8L-0.000976562 17.2C-0.000976562 18.52 1.07902 19.6 2.39902 19.6H21.599C22.919 19.6 23.999 18.52 23.999 17.2V2.8C23.999 1.48 22.919 0.400002 21.599 0.400002ZM21.119 5.5L12.635 10.804C12.251 11.044 11.747 11.044 11.363 10.804L2.87902 5.5C2.57902 5.308 2.39902 4.984 2.39902 4.636C2.39902 3.832 3.27502 3.352 3.95902 3.772L11.999 8.8L20.039 3.772C20.723 3.352 21.599 3.832 21.599 4.636C21.599 4.984 21.419 5.308 21.119 5.5Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.fb112076d9ee9eac1900ad6be0df4b32.svg";
export { ForwardRef as ReactComponent };